import { render, staticRenderFns } from "@/style-guide/partials/switch/switch.pug?vue&type=template&id=697d225f&scoped=true&lang=pug&external"
import script from "./switch.vue?vue&type=script&lang=ts"
export * from "./switch.vue?vue&type=script&lang=ts"
import style0 from "./switch.vue?vue&type=style&index=0&id=697d225f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697d225f",
  null
  
)

export default component.exports